import { useEffect, useState } from 'react';
import { AgxBodyText, AgxControlledCheckbox, AgxRow } from '@urbanx/agx-ui-components';
import { formatCurrencyAsNumber } from 'utils/formatNumber';

interface PriceItemProps {
  id: string;
  productName: string;
  pricePerUnit?: number;
  selected: boolean;
  onSelectProductChange: (value: {
    id: string;
    productName: string;
    pricePerUnit?: number;
    value: boolean;
  }) => void;
}

const PriceItem = ({
  id,
  productName,
  pricePerUnit,
  selected,
  onSelectProductChange,
}: PriceItemProps) => {
  const [productSelected, setProductSelected] = useState(selected);

  useEffect(() => {
    setProductSelected(selected === true);
  }, [selected]);

  useEffect(() => {
    onSelectProductChange({
      id,
      productName,
      pricePerUnit: pricePerUnit,
      value: productSelected,
    });
  }, [productSelected]);

  return (
    <AgxRow fill spaceBetween centered mediumGap extraClasses="marketingPackageItem">
      <AgxControlledCheckbox
        naked
        label={productName}
        checked={productSelected}
        onValueChanged={(value) => setProductSelected(value === true)}
        id={id}
      />
      <AgxBodyText small>${formatCurrencyAsNumber(pricePerUnit?.toString() ?? '', 2)}</AgxBodyText>
    </AgxRow>
  );
};

export default PriceItem;
